import React, {useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi'; 

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';

import './Testimonial.scss'; 

const Testimonial = () => {

  const [brands, setBrands] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  // State to keep track of testimonial we are currently viewing 
  const [currentIndex, setCurrentIndex] = useState(0);

  // handleClick function 
  const handleClick = (index) => {
    setCurrentIndex(index);
  }

  // Fetching Data from Sanity 
  // This useEffect() is only going to happen at the start of the application/ render of our component 
  useEffect(() => {
    const query = '*[_type == "testimonials"]';
    const brandsQuery = '*[_type == "brands"]';

    // Testimonials data
    client.fetch(query)
      .then((data) => {
        setTestimonials(data)
      })

    // Brands data
    client.fetch(brandsQuery)
      .then((data) => {
        setBrands(data)
      })

  }, [])

  const test = testimonials[currentIndex];

  return (
    <>
      {/* If there are testimonials then render  */}
      {testimonials.length && (
        <>
          <div className='app__testimonial-item app__flex'>
            <img src={urlFor(test.imgurl)} alt="testimonial" />
            <div className='app__testimonial-content'>
              <p className='p-text'>{test.feedback}</p>
              <div>
                <h4 className='bold-text'>{test.name}</h4>
                <h5 className='p-text'>{test.company}</h5>
              </div>
            </div>
          </div>

          <div className='app__testimonial-btns app__flex'>
            {/* If we are on the 1st testimonial then move to the last testimonial , else go to prev testimonial */}
            <div className='app__flex' onClick={() => handleClick(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1)}>
              <HiChevronLeft />
            </div>
            {/* If we are on the last testimonial then move to the 1st testimonial , else go to next testimonial */}
            <div className='app__flex' onClick={() => handleClick(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1)}>
              <HiChevronRight />
            </div>
          </div>
        </>
      )}

      <div className='app__testimonial-brands app__flex'>
        {brands.map((brand) => (
          <motion.div
            whileInView={{ opacity: [0, 1] }}
            transition={{ duration: 0.5, type: 'tween' }}
            key={brand._id}
          >
            <img src={urlFor(brand.imgUrl)} alt="brand.name" />
          </motion.div>
        ))}
      </div>
    </>
  )
}

// Double Wrapping Skills Component 
export default AppWrap(
  // Wrapping the Work component in MotionWrap and giving it an extra class name of app__work
  MotionWrap(Testimonial, 'app__testimonial'),
  // Giving the section an id of 'work'
  'testimonial',
  // Giving the section a white background (alternate background colors)
  "app__primarybg"
);